/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Reset_Panel_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Reset Panel" |
*
* @param {Style_Guide_Reset_Panel_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_reset_panel_aria_label = /** @type {((inputs?: Style_Guide_Reset_Panel_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Reset_Panel_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reinitialiser le panneau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Reset-Panel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pannello di ripristino")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Панель сброса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Panel de reinicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重置面板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パネルをリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रीसेट पैनल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Painel de reinicialização")
	return /** @type {LocalizedString} */ ("Reset Panel")
});